var _a;
import Immutable from 'immutable';
var SPORT_KEYS = 'sports';
var LEAGUE_KEYS = 'leagues';
var MATCH_KEYS = 'matches';
var SCORE_KEYS = 'scores';
var OUTCOME_KEYS = 'outcomes';
var RATE_KEYS = 'rates';
var repository = Immutable.fromJS((_a = {},
    _a[SPORT_KEYS] = {},
    _a[LEAGUE_KEYS] = {},
    _a[MATCH_KEYS] = {},
    _a[SCORE_KEYS] = {},
    _a[OUTCOME_KEYS] = {},
    _a[RATE_KEYS] = {},
    _a));
var ImmutableRepository = /** @class */ (function () {
    function ImmutableRepository() {
        this._repo = repository;
    }
    ImmutableRepository.prototype.addSport = function (id) {
        var key = { id: id };
        this._repo = this._repo.setIn([SPORT_KEYS, id], key);
        return key;
    };
    ImmutableRepository.prototype.getSportKey = function (id) {
        return this._repo.getIn([SPORT_KEYS, id]);
    };
    ImmutableRepository.prototype.removeSport = function (id) {
        this._repo = this._repo.deleteIn([SPORT_KEYS, id]);
        var leagues = this._repo.get(LEAGUE_KEYS).filter(function (l) { return l.sportId === id; }).map(function (l) { return l.id; }).toArray();
        for (var i = 0; i < leagues.length; i++) {
            this.removeLeague(leagues[i]);
        }
    };
    ImmutableRepository.prototype.addLeague = function (sportId, leagueId) {
        var key = {
            sportId: sportId,
            id: leagueId
        };
        this._repo = this._repo.setIn([LEAGUE_KEYS, leagueId], key);
        return key;
    };
    ImmutableRepository.prototype.getLeagueKey = function (id) {
        return this._repo.getIn([LEAGUE_KEYS, id]);
    };
    ImmutableRepository.prototype.removeLeague = function (leagueId) {
        var key = this._repo.getIn([LEAGUE_KEYS, leagueId]);
        this._repo = this._repo.deleteIn([LEAGUE_KEYS, leagueId]);
        var matches = this._repo.get(MATCH_KEYS).filter(function (m) { return m.leagueId === leagueId; }).map(function (l) { return l.id; }).toArray();
        for (var i = 0; i < matches.length; i++) {
            this.removeMatch(matches[i]);
        }
        return key;
    };
    ImmutableRepository.prototype.addMatch = function (leagueId, matchId) {
        var leagueKey = this._repo.getIn([LEAGUE_KEYS, leagueId]);
        var key = {
            sportId: leagueKey.sportId,
            leagueId: leagueId,
            id: matchId
        };
        this._repo = this._repo.setIn([MATCH_KEYS, matchId], key);
        return key;
    };
    ImmutableRepository.prototype.getMatchKey = function (id) {
        return this._repo.getIn([MATCH_KEYS, id]);
    };
    ImmutableRepository.prototype.removeMatch = function (matchId) {
        var key = this._repo.getIn([MATCH_KEYS, matchId]);
        this._repo = this._repo.deleteIn([MATCH_KEYS, matchId]);
        var scores = this._repo.get(SCORE_KEYS).filter(function (s) { return s.matchId === matchId; }).map(function (s) { return s.id; }).toArray();
        for (var i = 0; i < scores.length; i++) {
            this.removeScore(scores[i]);
        }
        var outcomes = this._repo.get(OUTCOME_KEYS).filter(function (o) { return o.matchId === matchId; }).map(function (o) { return o.id; }).toArray();
        for (var i = 0; i < outcomes.length; i++) {
            this.removeOutcome(outcomes[i]);
        }
        return key;
    };
    ImmutableRepository.prototype.addScore = function (matchId, scoreId) {
        var matchKey = this._repo.getIn([MATCH_KEYS, matchId]);
        var key = {
            sportId: matchKey.sportId,
            leagueId: matchKey.leagueId,
            matchId: matchKey.id,
            id: scoreId
        };
        this._repo = this._repo.setIn([SCORE_KEYS, scoreId], key);
        return key;
    };
    ImmutableRepository.prototype.getScoreKey = function (id) {
        return this._repo.getIn([SCORE_KEYS, id]);
    };
    ImmutableRepository.prototype.removeScore = function (scoreId) {
        var key = this._repo.getIn([SCORE_KEYS, scoreId]);
        this._repo = this._repo.deleteIn([SCORE_KEYS, scoreId]);
        return key;
    };
    ImmutableRepository.prototype.addOutcome = function (matchId, outcomeId) {
        var matchKey = this._repo.getIn([MATCH_KEYS, matchId]);
        var key = {
            sportId: matchKey.sportId,
            leagueId: matchKey.leagueId,
            matchId: matchKey.id,
            id: outcomeId
        };
        this._repo = this._repo.setIn([OUTCOME_KEYS, outcomeId], key);
        return key;
    };
    ImmutableRepository.prototype.getOutcomeKey = function (id) {
        return this._repo.getIn([OUTCOME_KEYS, id]);
    };
    ImmutableRepository.prototype.removeOutcome = function (outcomeId) {
        var key = this._repo.getIn([OUTCOME_KEYS, outcomeId]);
        this._repo = this._repo.deleteIn([OUTCOME_KEYS, outcomeId]);
        var rates = this._repo.get(RATE_KEYS).filter(function (r) { return r.outcomeId === outcomeId; }).map(function (r) { return r.id; }).toArray();
        for (var i = 0; i < rates.length; i++) {
            this.removeRate(rates[i]);
        }
        return key;
    };
    ImmutableRepository.prototype.addRate = function (outcomeId, rateId) {
        var outcomeKey = this._repo.getIn([OUTCOME_KEYS, outcomeId]);
        var key = {
            sportId: outcomeKey.sportId,
            leagueId: outcomeKey.leagueId,
            matchId: outcomeKey.matchId,
            outcomeId: outcomeKey.id,
            id: rateId
        };
        this._repo = this._repo.setIn([RATE_KEYS, rateId], key);
        return key;
    };
    ImmutableRepository.prototype.getRateKey = function (id) {
        return this._repo.getIn([RATE_KEYS, id]);
    };
    ImmutableRepository.prototype.removeRate = function (rateId) {
        this._repo = this._repo.deleteIn([RATE_KEYS, rateId]);
    };
    return ImmutableRepository;
}());
export default ImmutableRepository;



// WEBPACK FOOTER //
// ./src/repositories/ImmutableRepository.js